import React from 'react';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import LabeledCustomSelect from 'components/elements/LabeledCustomSelect';

const FilterLabel = ({ children }) => (
  <Typography
    sx={{
      fontSize: '0.875rem',
      color: '#989898',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    }}
  >
    {children}
  </Typography>
);

const Filters = ({
                   filters = {
                     segment: '',
                     xAxis: '',
                     yAxis: '',
                   },
                   segments = [],
                   yAxis = [],
                   setFilters = () => {},
                   view = '',
                   handleSwitch = () => {},
                 }) => {
  const { t } = useTranslation();

  const viewChart = [
    {
      id: 'twoD',
      name: '2 dimensions',
      value: 'twoD',
    },
    {
      id: 'oneD',
      name: '1 dimensional',
      value: 'oneD',
    },
  ];

  const selectStyles = {
    backgroundColor: '#fff',
    '.MuiOutlinedInput-notchedOutline': {
      top: 0,
      legend: { display: 'none' },
    },
    '.MuiInputBase-input': {
      fontSize: '0.875rem !important',
    },
    minWidth: '120px',
  };

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <Grid container spacing={2} sx={{ flexWrap: { xs: 'wrap', md: 'nowrap' } }}>
        {/* Segment Filter */}
        <Grid item xs={12} sm={6} md={4} lg={3}>
          <Grid container spacing={0.5}>
            <Grid item xs={12}>
              <FilterLabel>
                {t('feature.evaluate.summary.filters.segment')}
              </FilterLabel>
            </Grid>
            <Grid item xs={12}>
              <LabeledCustomSelect
                sx={selectStyles}
                id="select-segment"
                name="segment"
                height="20em"
                selectItems={segments}
                emptyPlaceholder={true}
                value={filters.segment}
                onChange={(e) => {
                  setFilters({
                    ...filters,
                    segment: e.target.value,
                  });
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        {/* Right Side Filters Container */}
        <Grid item xs={12} sm={12} md={8} lg={9}>
          <Grid container spacing={2}>
            {/* Y-Axis Filter */}
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Grid container spacing={0.5}>
                <Grid item xs={12}>
                  <FilterLabel>
                    {t('feature.evaluate.summary.filters.yAxis')}
                  </FilterLabel>
                </Grid>
                <Grid item xs={12}>
                  <LabeledCustomSelect
                    sx={selectStyles}
                    id="select-xAxis"
                    name="yAxis"
                    selectItems={yAxis}
                    value={filters.yAxis}
                    emptyPlaceholder={true}
                    onChange={(e) => {
                      setFilters({
                        ...filters,
                        yAxis: e.target.value,
                      });
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>

            {/* View Chart Filter */}
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Grid container spacing={0.5}>
                <Grid item xs={12}>
                  <FilterLabel>
                    {t('feature.evaluate.summary.filters.viewChart')}
                  </FilterLabel>
                </Grid>
                <Grid item xs={12}>
                  <LabeledCustomSelect
                    sx={selectStyles}
                    id="select-view"
                    name="viewChart"
                    emptyPlaceholder={true}
                    selectItems={viewChart}
                    value={view}
                    onChange={(e) => {
                      handleSwitch(e.target.value);
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Filters;